import { render } from "./SuccessDialog.vue?vue&type=template&id=1486003a&scoped=true"
import script from "./SuccessDialog.vue?vue&type=script&lang=js"
export * from "./SuccessDialog.vue?vue&type=script&lang=js"

import "./SuccessDialog.vue?vue&type=style&index=0&id=1486003a&lang=scss&scoped=true"

import exportComponent from "/var/www/hrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1486003a"]])

export default __exports__